import styled from "@emotion/styled";
import { AppBar, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";

export const RestaurantLogo = styled.img`
  width: 120px;
  height: 120px;
`;

export const NavAppBar = styled(AppBar)`
  display: flex;
  width: 100%;
  background: #fff;
  min-height: 72px;
  border: 1px solid #efefef;
`;

export const LeftIcon = styled(IconButton)`
  margin-right: 0;
  margin-left: "2%";
  color: #414141;

  /* Custom,
  iPhone Retina */
  @media only screen and (min-width: 320px) {
    margin-left: 1%;
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
    margin-left: 1%;
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
    margin-left: 5%;
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
    margin-left: 5%;
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
    margin-left: 5%;
  }
`;

export const RightNav = styled(Box)`
  
  &{
    flex: 1,
    display: flex;
    display: { xs: 'flex', md: 'none' };
    
 

  }
`;

export const NavLink = styled(Link)`
  & {
    background: #fff;
    list-style: none;
    color: #414141;
    text-decoration: none;
    padding: 7px;
    height: 52px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 10px;

    font-weight: bold;

    &:hover {
      background: #c70039;
      color: #fff;
    }
  }
`;

export const NavLinkNormal = styled(Link)`
  & {
    display: "flex";
    background: #fff;
    list-style: none;
    color: #414141;
    text-decoration: none;
    padding: 7px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 5px;
    margin-right: 10px;
  }
`;

export const LogoSmall = styled.img`
  height: 42px;
`;
